/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Fact_4Inputs */

const en_mk_hero_fact_4 = /** @type {(inputs: Mk_Hero_Fact_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free to get started`)
};

const id_mk_hero_fact_4 = /** @type {(inputs: Mk_Hero_Fact_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis untuk mulai`)
};

/**
* | output |
* | --- |
* | "Free to get started" |
*
* @param {Mk_Hero_Fact_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_fact_4 = /** @type {((inputs?: Mk_Hero_Fact_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Fact_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_fact_4(inputs)
	return en_mk_hero_fact_4(inputs)
});